import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MetadataExt, MetadataTypeIdentifier, MetadataValidatorIdentifier } from 'src/app/common/models/metadati/metadata';
import { FormFieldBase } from '../../dynamic-form-field/components/dynamic-form-light/models/form-field-base';
import { defaultValue, getFormFieldBase, mockValue } from '../components/mapper';
import { alphabeticValidator, currencyStringToNumber, currencyValidator, greaterThenOrEqualValidator, lessThenOrEqualValidator, numericValidator, rangeValidator, urlValidator } from '../../dynamic-form-field/validators/validators';
import { QuestionControlService } from 'src/app/core/components/dynamic-form/services/question-control.service';
import { QuestionBase } from 'src/app/core/components/dynamic-form/models/question-base';


@Component({
  selector: 'app-metadata-dynamic-form',
  templateUrl: './metadata-dynamic-form.component.html',
  styleUrls: ['./metadata-dynamic-form.component.css']
})
export class MetadataDynamicFormComponent implements OnInit, OnChanges{

  @Input() metadataList: MetadataExt[];
  @Output() metadataListChange: EventEmitter<MetadataExt[]> = new EventEmitter();
  form: FormGroup;
  @Output() formChange: EventEmitter<FormGroup> = new EventEmitter();
  @Input() isRicerca: boolean;
  metaSNAPSHOT: string;
  metadataListSNAPSHOT: MetadataExt[];
  questions: FormFieldBase[];

  constructor(private formBuilder : FormBuilder , private qcs: QuestionControlService ,private changeDetector: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.initForm(this.metadataList);
    if(this.form.valid){
      this.metadataListSNAPSHOT.forEach(meta => {
        if(meta.type.id === 'BINARY_CURSOR'){
          const control: AbstractControl = this.form.get(meta.identifier);
          meta.value = control.value;
        }
      })
      this.metadataListChange.emit(this.metadataListSNAPSHOT);
    }
    this.formChange.emit(this.form);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initForm(this.metadataList);
    this.formChange.emit(this.form);
  }


  initForm(metadata:MetadataExt[]) {
    this.questions = [];
    this.metaSNAPSHOT = JSON.stringify(metadata);
    this.metadataListSNAPSHOT = JSON.parse(this.metaSNAPSHOT);
    //this.metadataList = mockValue(this.metadataList)
    this.metadataListSNAPSHOT.forEach(element => {
      let formFieldBase = getFormFieldBase(element)
      if(this.isRicerca){
        formFieldBase.required = false;
      }
      if(!formFieldBase.value && formFieldBase.type === 'Valore binario'){
        formFieldBase.value = "false"
      }
      this.questions.push(formFieldBase)
    });
    this.form = this.qcs.toFormGroup(this.questions as QuestionBase[]);
    if(!this.isRicerca){
      this.metadataList.forEach(element => {
        this.addValidator(element);
      });
    }

  }

  onRetrieve(event: { key: string, event: any }){
    this.metadataListSNAPSHOT.forEach(element => {
      if(element.identifier === event.key){
        if(element.type.id === 'CURRENCY'){
          event.event = ''+ currencyStringToNumber(event.event);
        }
        if(Array.isArray(event.event)){
          if(event.event.length > 0){
            let arrayString = '';
              event.event.forEach(idOption => {
                arrayString = arrayString + idOption + ',';
              });
              element.value = arrayString.substring(0,arrayString.length - 1);
          } else {
            element.value = undefined;
          }


        } else {
          element.value = event.event;
        }
      }
      if(element.type.id === 'BINARY_CURSOR')

      if(!this.isRicerca && (!element.value || element.value.length === 0)){
        element.value = defaultValue(element)
      }

    });

    let control = this.form.get(event.key);
    control.setValue(event.event);

    this.changeDetector.detectChanges();

    this.formChange.emit(this.form);

    if(this.form.valid){
      this.metadataListChange.emit(this.metadataListSNAPSHOT);
    }


  }

  addValidator(metadata: MetadataExt) {

    if(metadata.type.id === MetadataTypeIdentifier.URL){
      this.form.get(metadata.identifier).addValidators(urlValidator());
    }

    let hasPunctuation: boolean = metadata.validators.some(s => s.id == MetadataValidatorIdentifier.PUNCTUATION);

    metadata.validators.forEach(validator => {
      let isDate = metadata.type.id === MetadataTypeIdentifier.DATE;
      let isCurrency = metadata.type.id === MetadataTypeIdentifier.CURRENCY;
      let valueCtrl: number;
      switch (validator.id) {
        case MetadataValidatorIdentifier.ALPHABETICAL:
          this.form.get(metadata.identifier).addValidators(alphabeticValidator(hasPunctuation));
          break;
        case MetadataValidatorIdentifier.NUMERIC:
          this.form.get(metadata.identifier).addValidators(numericValidator(hasPunctuation));
          break;
        case MetadataValidatorIdentifier.CURRENCY:
          this.form.get(metadata.identifier).addValidators(currencyValidator());
          break;
        case MetadataValidatorIdentifier.URL:
          this.form.get(metadata.identifier).addValidators(urlValidator());
          break;
        case MetadataValidatorIdentifier.LENGTH:

          let min : number;
          let max : number;
          let values = validator.value.split('-');
          if(values[0]){
            min = parseInt(values[0]);
          }
          if(values[1]){
            max = parseInt(values[1]);
          }
          this.form.get(metadata.identifier).addValidators(rangeValidator(min,max,false));
          break;
        case MetadataValidatorIdentifier.LESS_THAN_OR_EQUAL:
          if(isCurrency) {
            valueCtrl = parseFloat(validator.value);
          } else {
            valueCtrl = parseInt(validator.value);
          }
          this.form.get(metadata.identifier).addValidators(lessThenOrEqualValidator(valueCtrl,isDate, isCurrency));
          break;
        case MetadataValidatorIdentifier.GREATER_THAN_OR_EQUAL:
          if(isCurrency) {
            valueCtrl = parseFloat(validator.value);
          } else {
            valueCtrl = parseInt(validator.value);
          }
          this.form.get(metadata.identifier).addValidators(greaterThenOrEqualValidator(valueCtrl,isDate, isCurrency));
          break;
        default:
          break;
      }

    });


  }

  resetForm() {
    this.form.reset();
  }

}
